import * as React from 'react';
import { useEffect, useState } from 'react';
import BentoBox from '../BentoBox';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { useAtom } from 'jotai';
import { fullscreenBoxAtom, isFullscreenExhaustedAtom } from '@/store';
import { BentoBox as BentoBoxType } from 'types/generated';
import { fetchBentoBox } from '@/clients/BentoBoxUtils';

interface BentoBoxId {
  data: {
    items: {
      sys: {
        id: string;
      };
    }[];
  };
}

const LayoutEleven = (data: BentoBoxId) => {
  const bentoBoxId = data.data.items[0]?.sys?.id;
  const [bentoBox, setBentoBox] = useState<BentoBoxType>({} as BentoBoxType);
  const [isFullscreenExhausted, setIsFullscreenExhausted] = useAtom(isFullscreenExhaustedAtom);
  const [isFullscreenBox, setFullscreenBox] = useAtom(fullscreenBoxAtom);

  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: false, amount: 'all' });

  useEffect(() => {
    if (isInView && !isFullscreenExhausted) {
      setFullscreenBox(true);
    } else {
      setFullscreenBox(false);
    }
  }, [bentoBoxId, isInView, isFullscreenExhausted, setFullscreenBox]);

  useEffect(() => {
    const fetchBox = async () => {
      if (bentoBoxId) {
        const box = await fetchBentoBox(bentoBoxId);
        if (box) {
          setBentoBox(box);
        }
      }
    };
    fetchBox().then();
  }, [bentoBoxId]);

  const cancelFullscreenHandler = () => {
    if (!isFullscreenExhausted) {
      setIsFullscreenExhausted(true);
    }
    setTimeout(() => {
      document.removeEventListener('scroll', cancelFullscreenHandler);
      document.removeEventListener('click', cancelFullscreenHandler);
      document.removeEventListener('touchstart', cancelFullscreenHandler);
      document.removeEventListener('touchmove', cancelFullscreenHandler);
      document.removeEventListener('touchend', cancelFullscreenHandler);
      document.body.classList.remove('overflow-y-hidden');
    }, 300);
  };
  if (!isFullscreenExhausted) {
    document.addEventListener('scroll', cancelFullscreenHandler);
    document.addEventListener('click', cancelFullscreenHandler);
    document.addEventListener('touchstart', cancelFullscreenHandler);
    document.addEventListener('touchmove', cancelFullscreenHandler);
    document.addEventListener('touchend', cancelFullscreenHandler);
    document.body.classList.add('overflow-y-hidden');
  }

  if (!bentoBox) {
    return <p>Loading bento box...</p>;
  }

  return (
    <div ref={ref} className="min-h-[70vh] w-full">
      <AnimatePresence mode="popLayout">
        <motion.div
          layoutId={`bento-box-${bentoBoxId}`}
          layout
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          className={`${
            isFullscreenBox
              ? 'absolute inset-0 z-20 flex items-center justify-center'
              : 'relative h-full w-full overflow-hidden'
          }`}
          onWheel={cancelFullscreenHandler}
        >
          <BentoBox
            box={bentoBox}
            isFullscreen={isFullscreenBox}
            OnClick={() => {
              setIsFullscreenExhausted(true);
              setFullscreenBox(false);
            }}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default LayoutEleven;
